import { render, staticRenderFns } from "./VersaoRelatorioDialog.vue?vue&type=template&id=6f3d1d67"
import script from "./VersaoRelatorioDialog.vue?vue&type=script&lang=js"
export * from "./VersaoRelatorioDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports